export const sideImage = '/images/sideImage.png';
export const logoLightMode = '/images/logo_light_mode.png';
export const logoDarkMode = '/images/logo_dark_mode.png';
export const propNewChallengeImage = '/images/propNewChallengeImage.png';
export const propNewChallengeImageDark = '/images/propNewChallengeImageDark.png';
